import React from "react";
import { useNavigate } from "react-router-dom";
import { TeamPageNavigation } from "@/pages/People";
import { useVesselNavigation } from "./VesselNavigation";
import { TotoAdaptiveDock } from "./TotoAdaptiveSurface";
import "./today-layout.css";

// Keep the workspace heading, date, navigation and page actions in one shell
// as implemented Team Stewardship pages are added.
const PAGES = [
  { id: "employee-records", label: "Employment Records", to: "/workspaces/team-stewardship" },
  { id: "annual-review", label: "Annual Review", to: "/workspaces/team-stewardship?view=annual-review" },
  { id: "coaching-development", label: "Coaching & Development", to: "/workspaces/team-stewardship?view=coaching-development" },
  { id: "disciplinary-action", label: "Disciplinary Action", to: "/workspaces/team-stewardship?view=disciplinary-action" },
  { id: "record-audit", label: "Record Audit", to: "/workspaces/team-stewardship?view=record-audit" },
];
export default function TeamStewardshipLayout({ current = "employee-records", actions, navigationActions, beforeLeave, children }) {
  const navigate = useNavigate();
  const items = PAGES.map(item => ({ ...item, selected: item.id === current }));
  useVesselNavigation({ label: "Team Stewardship", priority: 10, items, beforeLeave });
  const follow=to=>{const action=()=>navigate(to);if(beforeLeave?.(action)!==false)action();};
  const today = new Date();
  return <main className="toto-workspaces today-layout team-stewardship" data-testid="team-stewardship">
    <section className="toto-workspaces__vessel today-layout__vessel" aria-labelledby="stewardship-title">
      <div className="today-layout__heading"><header className="today-arrival-heading">
        <h1 id="stewardship-title">Team Stewardship</h1>
        <time dateTime={today.toLocaleDateString("en-CA")}>{today.toLocaleDateString([], { weekday: "long", month: "long", day: "numeric", year: "numeric" })}</time>
      </header></div>
      <div className="today-layout__navigation"><TeamPageNavigation items={items} navigate={follow} label="Team Stewardship navigation">{navigationActions}</TeamPageNavigation></div>
      <div className="today-layout__content">
        {actions && <div className="today-layout__local-tools" aria-label="Page actions">{actions}</div>}
        {children}
      </div>
    </section>
    <TotoAdaptiveDock active="workspace" destinations={[]} />
  </main>;
}
